import {Pipe, PipeTransform} from '@angular/core';
import {PaymentDto} from '../../../Models/Finances/Payments/payment.interface';

@Pipe({
  name: 'payments',
  standalone: false
})
export class PaymentsPipe implements PipeTransform {

  transform(items: PaymentDto[], filter: {
    local?: number;
    service?: number;
    menu: string;
    cashClosing: number
  }): PaymentDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    items = items.filter((item) => filter.menu === 'extras' ? item['extra'] : !item['extra']);

    if (filter.local) {
      items = items.filter((item) => item['id_local'] === filter.local);
    }

    if (filter.service) {
      items = items.filter((item) => item['id_turno'] === filter.service);
    }

    if (filter.cashClosing) {
      items = items.filter((item) => item['id_cierre'] == filter.cashClosing);
    }

    return items;

  }

}
